angular.module('impactx.catalog').controller('CatalogChangeProtocolSelectionCtrl', [
    '$scope',
    'catalogId',
    '$mdDialog',
    'TranslationService',
    'dataGen',
    'ToastService',
    'DownloadService',
    '$redirect',
    CatalogChangeProtocolSelectionCtrl]);

function CatalogChangeProtocolSelectionCtrl($scope, catalogId, $mdDialog, TranslationService, dataGen, ToastService,
                                            DownloadService, $redirect) {
    $scope.oneSelected = false;
    var self = this;
    dataGen.getData($scope, {catalogId: catalogId}, "/catalog/rule/changerules").then(function () {
        $scope.trns.abort = TranslationService.get('abort');
        self.checkOneSelected();
    });

    this.cancel = function () {
        $mdDialog.cancel();
    };
    this.answer = function () {
        var dataObj = {
            catalogId: catalogId,
            selection: $scope.data
        };
        dataGen.postAsForm($scope, dataObj, "/catalog/rule/performchangerules").then(function (data) {
            $mdDialog.hide();
            if(data.warnings.length === 0)
            {
                ToastService.openStandardToast($scope.trns.changeRuleRunStarted);
            }
        });
    };

    this.checkOneSelected = function () {
        $scope.oneSelected = false;
        for (var i = 0; i < $scope.data.rules.length; i++) {
            if ($scope.data.rules[i].selected) {
                $scope.oneSelected = true;
                break;
            }
        }
    };

    this.downloadChangeProtocol = function () {
        DownloadService.openDownloadPost('/catalog/rule/downloadchangeprotocol', {paramName: "id", paramValue: parseInt($scope.data.changeProtocol.id)})
    };

    this.redirectToSystemRules = function () {
        $mdDialog.cancel();
        $redirect.redirectTo(null, "catalogsystemrules");
    };

}